import { RcFile } from 'antd/lib/upload';
import imageCompression from 'browser-image-compression';
import { TFunction } from 'react-i18next';

export const beforeImageUploadValidator = async (
  file: RcFile,
  t: TFunction
) => {
  const allowedMimeTypes = ['image/jpeg', 'image/png'];
  const isAllowedType = allowedMimeTypes.includes(file.type);
  const isLessThan5M = file.size / 1024 / 1024 < 5;

  if (!isLessThan5M) {
    throw new Error(t('mustBeLessThan', { mb: 5 }));
  }

  if (!isAllowedType) {
    throw new Error(t('invalidFileType'));
  }

  try {
    return await imageCompression(file, {
      maxSizeMB: 1, // Specifies the maximum size of the image after compression
      maxWidthOrHeight: 1920, // Limit on maximum width or height of image after compression
      useWebWorker: true, // Specifies whether to use Web Worker to perform image compression
    });
  } catch (error: any) {
    throw new Error(t('compressionFailed'));
  }
};
